'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'parachute-box';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f4cd';
var svgPathData = ['M16.8 208l95.2 0c0-80.9 32-151 78.6-185.4C76.6 47.1 23.6 134.9 16.8 208zM128 208l256 0c0-54.6-15.3-103.3-39.3-138C320.6 35.3 289 16 256 16s-64.6 19.3-88.7 54c-24 34.6-39.3 83.4-39.3 138zm48 160l0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32zM321.4 22.6C368 57 400 127.1 400 208l95.2 0c-6.8-73.1-59.8-160.9-173.9-185.4z', 'M256.1 0L256 0C86.6 0 8.7 114.4 .7 208c-.8 8.8 6.5 16 15.3 16l36.7 0L168.9 340.2c-5.6 7.8-8.9 17.4-8.9 27.8l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-10.4-3.3-20-8.9-27.8L459.3 224l36.7 0c8.8 0 16.1-7.2 15.3-16c-8-93.6-85.8-208-255.2-208zM436.7 224L331.8 328.9c-7.8-5.6-17.4-8.9-27.8-8.9l-40 0 0-96 119.6 0 16 0 37.1 0zM248 224l0 96-40 0c-10.4 0-20 3.3-27.8 8.9L75.3 224l37.1 0 16 0L248 224zM190.6 22.6C144 57 112 127.1 112 208l-95.2 0C23.6 134.9 76.6 47.1 190.6 22.6zM167.3 70c24-34.7 55.6-54 88.7-54s64.6 19.3 88.7 54c24 34.6 39.3 83.4 39.3 138l-256 0c0-54.6 15.3-103.3 39.3-138zM495.2 208L400 208c0-80.9-32-151-78.6-185.4C435.4 47.1 488.4 134.9 495.2 208zM304 336c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32l96 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faParachuteBox = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;